import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    menu: {
                        route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                        text: 'home.title',
                        icon: 'fas fa-home',
                    },
                    acl: {
                        view: 'IG_00013',
                    },
                },
                settings: {
                    menu: {
                        route: `${code}.settings`,
                        text: 'settings.titles',
                        icon: 'fas fa-cogs',
                    },
                    acl: {
                        view                    : 'IG_00021',
                        edit                    : 'IG_00022',
                    },
                    url: {
                        getConfig               : `/${codeAPI}/gestao/definitions`,
                    },
                },
                default_layers: {
                    menu: {
                        route: `${code}.default_layers`,
                        text: 'default_layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'IG_00023',
                        detail                  : 'IG_00024',
                        add                     : 'IG_00025',
                        edit                    : 'IG_00026',
                        delete                  : 'IG_00027',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/defaultlayers`,
                        getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                        getCreate               : `${codeAPI}/gestao/defaultlayers`,
                        getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                        getResources            : `${codeAPI}/gestao/defaultlayers/resources`,
                    },
                },
                layers: {
                    menu: {
                        route: `${code}.layers`,
                        text: 'layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'IG_00017',
                        detail                  : 'IG_00016',
                        add                     : 'IG_00014',
                        edit                    : 'IG_00015',
                        delete                  : 'IG_00018',
                        private                 : 'IG_00014',
                    },
                    url: {
                        getList: `${codeAPI}/gestao/layers`,
                        getShow: `${codeAPI}/gestao/layers/:id`,
                        getCreate: `${codeAPI}/gestao/layers`,
                        getUpdate: `${codeAPI}/gestao/layers/:id`,
                        getDelete: `${codeAPI}/gestao/layers/:id`,
                        getLists: `${codeAPI}/gestao/layers/lists`,
                        getResources: `${codeAPI}/gestao/layers/resources`,
                        describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                    },
                },
                print_visible_emissions: {
                    menu: {
                        route: `${code}.print_visible_emissions.config`,
                        text: 'print_visible_emissions.titles',
                        icon: 'fas fa-print',
                    },
                    acl: {
                        view                    : 'IG_00019',
                        config                  : 'IG_00019',
                        configEdit              : 'IG_00020',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/printvisible`,
                        getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                        getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                    },
                },
            },
            tools: {

            }
        }
    };
};

const state = getDefaultState();

export default state;